module.exports = __webpack_public_path__ + "static/media/icon-nav-notification.e1c86986.svg";